import usa from "./usa.png"
import germany_flag from "./germany.png"
import { useEffect, useState } from "react"
import { OutSideClickHandler } from "components"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"

interface languageStructure {
 id: number
 icon: any
 lang: string
 country: string
}

export const Language = () => {
 const [isOpen, setIsOpen] = useState(false)
 const [select, setSelect] = useState<languageStructure>()
 const [languages] = useState<languageStructure[]>([
  {
   id: 1,
   country: "german",
   lang: "gr",
   icon: germany_flag,
  },
  {
   id: 2,
   country: "English",
   lang: "en",
   icon: usa,
  },
 ])
 const { i18n } = useTranslation("translation")

 useEffect(() => {
  const language: languageStructure | undefined = languages.find(
   (lan) => lan.lang === i18n.language,
  )
  language && setSelect({ ...language })
 }, [i18n.language, languages])

 const outSideClickHandler = () => {
  setTimeout(() => {
   setIsOpen(false)
  }, 300)
 }

 const languageHandler = (lang: string, id: number) => {
  const selectedLanguage = languages.find((language) => language.id === id)
  setSelect(selectedLanguage)
  setIsOpen(false)
  i18n.changeLanguage(lang)
 }
 return (
  <div className="relative z-40">
   <div className="flex relative items-center justify-center ">
    <button
     onClick={() => setIsOpen(!isOpen)}
     type="button"
     className="inline-flex items-center justify-center w-full rounded-md border border-gray-300 shadow-sm text-sm font-medium text-gray-700 focus:outline-none p-1 lg:p-3"
     aria-expanded={isOpen}
    >
     {i18n.language && (
      <div className="w-[25px] xl:w-[25px]">
       <img src={select?.icon} alt="" className="w-full" />
      </div>
     )}
    </button>
   </div>
   <div className="absolute lg:top-20 top-10 left-[-100px] right-0 lg:right-0 lg:left-[-100px]">
    {isOpen && (
     <OutSideClickHandler callback={outSideClickHandler}>
      <Box
       color="text"
       bg="highlight"
       className="border mt-2 w-[95%] lg:w-96 rounded-md shadow-lg ring-1 ring-black ring-opacity-5"
       role="menu"
       aria-orientation="vertical"
      >
       <div className="py-1 mx-2 grid grid-cols-1 gap-1 lg:grid-cols-2 lg:gap-2" role="none">
        {languages.map((language, index) => {
         return (
          <button
           key={index}
           onClick={() => {
            languageHandler(language.lang, language.id)
           }}
           className={`${
            select?.id === language.id ? "bg-gray text-black" : ""
           } block px-4 py-2 text-sm text-start items-center inline-flex hover:bg-gray ${
            index % 2 === 0 ? "rounded-r" : "rounded-l"
           }`}
           role="menuitem"
          >
           <img className="mr-2" src={language.icon} width={25} alt="" />
           <p className="">{language.country}</p>
          </button>
         )
        })}
       </div>
      </Box>
     </OutSideClickHandler>
    )}
   </div>
  </div>
 )
}
